<template>
  <svg
    version="1.1"
    viewBox="0 0 256 371"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="background-color: #eef1f2"
  >
    <rect height="371" width="256" x="0" y="0" fill="#EEF1F2"></rect>
    <path
      d="M162.40625,77 L162.40625,90.5625 L40.34375,90.5625 C36.5983809,90.5625 33.5625,93.5983809
      33.5625,97.34375 L33.5625,97.34375 L33.5625,236.969687 L96.628125,173.971875
      C99.2732363,171.342445 103.544576,171.342445 106.189687,173.971875 L106.189687,173.971875
      L148.84375,216.625937 L184.784375,180.753125 C187.429486,178.123695 191.700826,178.123695
      194.345938,180.753125 L194.345938,180.753125 L223.4375,209.844687 L223.4375,158.375
      L237,158.375 L237,273.65625 C237,284.891934 227.891934,294 216.65625,294 L216.65625,294
      L40.34375,294 C29.1080664,294 20,284.891934 20,273.65625 L20,273.65625 L20,97.34375
      C20,86.1080664 29.1080664,77 40.34375,77 L40.34375,77 L162.40625,77 Z M82,114
      C93.045625,114 102,122.954375 102,134 C102,145.045625 93.045625,154 82,154 C70.954375,154
      62,145.045625 62,134 C62,122.954375 70.954375,114 82,114 Z M175.444623,100.396089
      L183.687219,108.661381 C184.620423,109.602859 184.620423,111.123422 183.680918,112.077314
      C182.737148,113.018189 181.212972,113.018189 180.26465,112.073775 L180.26465,112.073775
      L177.727,109.527 L177.745354,109.644062 C179.677469,121.418749 189.812727,130.462066
      202.047328,130.661575 L202.047328,130.661575 L202.460517,130.664942 C209.153157,130.664942
      215.436777,128.056193 220.174617,123.31173 C221.12269,122.361456 222.670209,122.361776
      223.58594,123.311542 C224.527282,124.25405 224.527282,125.78338 223.586285,126.726562
      C217.94114,132.382374 210.431948,135.5 202.451652,135.5 C187.460762,135.5 174.984785,124.35392
       172.907406,109.825508 L172.907406,109.825508 L172.902,109.787 L170.627234,112.068625
       C170.216136,112.485215 169.674234,112.730073 169.104127,112.774878 L169.104127,112.774878
       L168.913187,112.782365 C168.276718,112.782365 167.658303,112.532522 167.207809,112.075026
       C166.263587,111.129629 166.263587,109.597657 167.206898,108.658263 L167.206898,108.658263
       L175.444623,100.396089 Z M202.54801,75.5 C217.536718,75.5 230.012345,86.6439604
       232.093604,101.171817 L232.093604,101.171817 L232.098,101.21 L234.379146,98.9226859
       C235.281116,98.0234824 236.717815,97.9826095 237.660635,98.8020572 L237.660635,98.8020572
       L237.791853,98.9249739 C238.734405,99.8686992 238.736601,101.398026 237.795291,102.341522
       L237.795291,102.341522 L229.557794,110.600807 L221.31437,102.338232 C220.381166,101.396755
       220.381166,99.876192 221.320671,98.9222996 C222.265013,97.9808537 223.794144,97.9808537
       224.736486,98.9253846 L224.736486,98.9253846 L227.277,101.473 L227.259636,101.355612
       C225.324141,89.5799272 215.187742,80.5375269 202.954224,80.3380384 L202.954224,80.3380384
       L202.541072,80.3346719 C195.847619,80.3346719 189.562063,82.9439869 184.830962,87.683869
       C183.887384,88.6368031 182.34531,88.6368031 181.414841,87.6918832 C180.466611,86.7485972
       180.466611,85.2139736 181.411064,84.2734376 C187.057027,78.6168059 194.564245,75.5
       202.54801,75.5 Z"
      fill="#DBE2E5"
      fill-rule="nonzero"
    ></path>
  </svg>
</template>
